const Loader = ({isLoading}) => {
  return (
    <div hidden={!isLoading} class="spinner-border text-primary" role="status" />
  )
}

export default Loader
